import { Users } from '@platform/client';
import { EditProfileRootPro } from './EditProfileRootPro';
import { EditProfileRootOrg } from './EditProfileRootRep';

export const EditProfileRoot = () => {
  const { data: userData } = Users.useGetCurrentUser();
  if (!userData) {
    return null;
  }
  if (userData.accountType === 'experteer') {
    return <EditProfileRootPro />;
  } else if (userData.accountType === 'organization') {
    return <EditProfileRootOrg />;
  } else {
    return <p>Edit Profile Not Supported</p>;
  }
};
